export default [
  'mortgage_and_rent',
  'telephone_services',
  'other_debt_payments',
    'health_insurance',
    'vehicle_purchase_and_lease',
    'vehicle_maintenance_and_repairs',
    'life_and_personal_insurance',
    'vehicle_insurance',
    'electricity',
    'telephone_services',
    'water_and_public_services',
    'heating_fuels_other',
    'natural_gas',
    'media_hardware_and_services',
  ]